import React, { Fragment } from 'react';

import { AppLogic } from '../../components/AppLogic/AppLogic';
import { GlobalLayout } from '../../components/Layouts/GlobalLayout';
import MainMap from '../../components/Maps/components/MainMap';
import { MetaTags } from '../../components/MetaTags/MetaTags';
import { META_EXPLORE_TITLE } from '../../constants/constants';
import { MapProvider } from '../../contexts/MapContext';
import { MapLayersProvider } from '../../contexts/MapLayersContext';

import { MapDrawer } from './components/MapDrawer/MapDrawer';
import { MapMenu } from './components/MapMenu/MapMenu';
import { ExploreProvider, useExplore } from './context/ExploreContext';
import { useGeolocation } from '../../contexts/GeolocationContext/GeolocationContext';

const Explore = () => {
  const { exploreQueryParams } = useExplore();
  const { drawerView } = exploreQueryParams;
  const isDrawerOpened = drawerView !== undefined;
  const { isLoading } = useGeolocation();

  return (
    <>
      <div
        className={`fixed left-0 top-0 flex min-h-full w-full pt-[var(--main-navigation-height-mobile)] sm:z-auto sm:pt-[var(--main-navigation-height)] ${
          isDrawerOpened ? 'z-modal' : ''
        }`}
      >
        <MetaTags
          title={META_EXPLORE_TITLE}
          description="Use our interactive map to find fishing spots near you. Click on nearby waters to see recent catches, reviews and more. Try it out today!"
          link="/explore"
        />
        <div className="flex grow flex-col sm:flex-row-reverse">
          <div className="flex grow">{isLoading ? <></> : <MainMap />}</div>
          {isDrawerOpened && (
            <div className="flex w-full sm:relative sm:w-[375px]">
              <div>
                <div className="absolute bottom-0 left-0 top-32 z-modal w-full overflow-y-auto rounded-t-lg bg-lake-fog scrollbar-none sm:top-0 sm:z-auto sm:w-[375px]">
                  <MapDrawer />
                </div>
              </div>
            </div>
          )}
          <MapMenu />
        </div>
      </div>
    </>
  );
};

const ExploreWrapper = ({
  // useful for testing when we want to mock this provider
  mockMapProvider = false,
}: {
  mockMapProvider?: boolean;
}) => {
  const MapProviderComponent = mockMapProvider ? Fragment : MapProvider;
  return (
    <MapProviderComponent>
      <ExploreProvider>
        <MapLayersProvider>
          <Explore />
        </MapLayersProvider>
      </ExploreProvider>
    </MapProviderComponent>
  );
};

ExploreWrapper.getLayout = function getLayout(page: any) {
  return (
    <AppLogic pageProps={page.props}>
      <GlobalLayout hideStickyBannerGetApp hideFooter disableSupportChat>
        {page}
      </GlobalLayout>
    </AppLogic>
  );
};

// Default export to allow for wrapper

export default ExploreWrapper;
